import { render, staticRenderFns } from "./ExistingResourceSelector.vue?vue&type=template&id=25ea8fd4&"
import script from "./ExistingResourceSelector.vue?vue&type=script&lang=js&"
export * from "./ExistingResourceSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports